var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"10"}},[_c('h4',{staticClass:"text-h5"},[_vm._v(" Nowy kontrahent ")])]),_c('v-col',{attrs:{"cols":"2"}},[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Zapisz")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }